/**
 * Removal job order summary (public link + private preview).
 * Uses the same template, CSS class names, and layout as `Order_summary.tsx`.
 * Kind routing and removal/installation math live under `components/orderSummary/`; this file is the route entry re-export.
 */
export { default } from "./Order_summary";
